<template lang="pug">
    nav.header-menu(v-if="items && items.length")
        .navbar-brand
            a.navbar-item(href='#') Schrift vergrößern
        .navbar-menu.is-pulled-right.navbar-end
            tree-menu(:items="items" :max-depth="1" :allow-multiple-active-items="true" :delay="100")
</template>
<script>

// import _ from 'lodash'
import get from 'lodash.get'
import cloneDeep from 'lodash.clonedeep'
import { mapGetters } from 'vuex'

import NestedSet from '@/nested-set-lib'

export default {
    name: 'HeaderMenu',
    computed: {
        items() {
            const menu = this.menus.find(menu => menu.key === 'header-menu')
            let items = get(menu, 'menuItems') || []
            items = cloneDeep(items)

            if (items.length) {
                return NestedSet.createTree(items)
            }

            return items
        },
        ...mapGetters({
            menus: 'menus',
        })
    }
}
</script>

<style lang="sass" scoped>

    @import "~bulma/sass/utilities/mixins";

    nav.header-menu
        display: none
        +desktop
            display: flex
            background-color: #4c4c4c
            color: #fff
            .navbar-brand a
                color: inherit
            .navbar-menu
                & /deep/
                    li
                        display: inline-block
                        & > .tree-item a
                            color: #fff
                            height: 52px
                            line-height: 52px
                            text-transform: uppercase
                            padding: 0 22px
                            display: inline-block
                        &.visible > .tree-item a
                            background-color: #666666
</style>
